import { useLocalObservable } from 'mobx-react';
import React from 'react';
import { createStore, TStore } from './store';


export const StoreContext = React.createContext<TStore | null>(null);

export const StoreProvider: React.FC = ({ children }): JSX.Element => {
  const store = useLocalObservable(() => createStore);
  return <StoreContext.Provider value={store}>{children}</StoreContext.Provider>;
};

export const useStore = ():TStore => {
  const store = React.useContext(StoreContext);
  if (!store) {
    throw new Error('You have forgot to use StoreProvider');
  }
  return store;
};
